import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.last-index-of.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _props$data$props$wat;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchActiveGet as fetchDetail, fetchActiveUpload as fetchUpdate } from "@/api/PMS/communityPartyBuilding/activityManage";
export default (_props$data$props$wat = {
  props: {
    showDialog: Boolean,
    isDetail: Boolean,
    keyValue: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    return {
      rules: {},
      uploadUrl: "",
      downloadUrl: "",
      addList: [],
      uploadList: [],
      dialogImageUrl: "",
      picUrl: "",
      imageUrl: "",
      dialogVisible: false,
      fileList: [],
      childData: {}
    };
  }
}, _defineProperty(_props$data$props$wat, "props", {
  keyValue: {
    type: Number,
    default: -1
  }
}), _defineProperty(_props$data$props$wat, "watch", {
  showDialog: function showDialog(n, o) {
    if (n) {
      this.$refs.dataForm.resetFields();
      this.init();
    }
  }
}), _defineProperty(_props$data$props$wat, "created", function created() {
  this.uploadUrl = process.env.VUE_APP_UPLOAD;
  this.downloadUrl = process.env.VUE_APP_DOWNLOAD; // 获取路由的配置

  var appType = this.$route.query.appType;

  if (appType !== undefined) {
    this.childData.appType = parseInt(appType);
  }

  this.init();
}), _defineProperty(_props$data$props$wat, "methods", {
  init: function init() {
    var _this = this;

    this.delFileList = [];
    this.fileList = [];
    this.files = [];
    this.addList = [];
    this.removeList = [];
    this.$nextTick(function () {
      _this.$refs["dataForm"].clearValidate();
    });

    if (this.keyValue > 0) {
      this.childData = {};
      fetchDetail({
        activityManageId: this.keyValue
      }).then(function (res) {
        if (res.data.code === 200) {
          _this.childData = response.data.data;
          _this.files = _this.childData.map(function (item) {
            return {
              fileId: item.fileId,
              name: item.fileName,
              url: item.fileId
            };
          });
          _this.fileList = _this.files;
        }
      });
    }
  },
  handCreate: function handCreate() {
    var _this2 = this;

    this.$refs["dataForm"].validate(function (valid) {
      if (valid) {
        _this2.childData.id = _this2.keyValue;
        _this2.childData.changeActiveFileVos = _this2.fileList;
        fetchUpdate(_this2.childData).then(function () {
          _this2.$emit("handCancle", true);

          _this2.Alert({
            alertType: "update"
          });
        });
      } else {
        _this2.Alert({
          alertType: "valid"
        });
      }
    });
  },
  // 上传图片成功时获取服务器图片URL
  handleSuccess: function handleSuccess(response, file) {
    this.fileList.push({
      fileId: file.response.data[0].fileId //name: file.response.data[0].fileName,

    });
  },
  handleError: function handleError(err, file) {
    var res = JSON.parse(err.message);
    this.$message({
      message: res.message,
      type: "error"
    });
  },
  handleExceed: function handleExceed() {},
  handlePreview: function handlePreview(file) {
    if (file.response) {
      // 当还未保存到业务逻辑中时的预览图片
      if (file.name.includes("png") || file.name.includes("jpg") || file.name.includes("jpeg")) {
        // 当附件是图片的时候在线打开
        this.dialogVisible = true;
        this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
      } else {
        // 当附件是文件的时候在线下载
        this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
        this.handleDownload(this.dialogImageUrl, file.name);
      }
    } else {
      // 当已保存到业务逻辑中时的预览图片
      if (file.name.includes("png") || file.name.includes("jpg") || file.name.includes("jpeg")) {
        // 当附件是图片的时候在线打开
        this.dialogVisible = true;
        this.dialogImageUrl = this.downloadUrl + file.url;
      } else {
        // 当附件是文件的时候在线下载
        this.dialogImageUrl = this.downloadUrl + file.url;
        this.handleDownload(this.dialogImageUrl, file.name);
      }
    }
  },
  // 移除图片之前做的操作
  beforeRemove: function beforeRemove(file, fileList) {// return this.$confirm(`确定移除 ${ file.name }？`)
  },
  beforeUpload: function beforeUpload(file) {
    var extension = file.name.substring(file.name.lastIndexOf(".") + 1);
    extension = extension.toLowerCase();
    var isLt2M = file.size / 1024 / 1024 < 10;
    var fileFormatOK = extension === "jpg" || extension === "jpeg" || extension === "png" || extension === "pdf";

    if (!fileFormatOK) {
      this.$message({
        message: "只支持上传 jpg/jpeg/png/pdf 格式文件!",
        type: "error"
      });
      return false;
    }

    if (!isLt2M) {
      this.$message({
        message: "上传文件大小不能超过 10MB!",
        type: "error"
      });
      return false;
    }
  },
  // 移除图片
  handleRemove: function handleRemove(file, fileList) {
    var _this3 = this;

    var currentUrl = 0; // 获取当前删除文件的url

    if (file.response !== undefined) {
      // 文件是新增加的
      currentUrl = file.response.data[0].fileId;
    } else {
      // 文件是旧数据
      currentUrl = file.url;
    }

    this.fileList.forEach(function (item, index) {
      if (currentUrl === item.url) {
        _this3.fileList.splice(index, 1);

        return;
      }
    });
    this.oldImgList.forEach(function (col, n) {
      if (currentUrl === col.filePath) {
        _this3.removeList.push(col.fileId);

        return;
      }
    });
    this.addList.forEach(function (item, index) {
      if (item.filePath === currentUrl) {
        _this3.addList.splice(index, 1);
      }
    });
  },
  // 下载文件
  handleDownload: function handleDownload(url, name) {
    var link = document.createElement("a");
    link.style.display = "none";
    link.href = url;
    link.setAttribute("download", name);
    document.body.appendChild(link);
    link.click();
  },
  // 判断上传的文件类型，方便数据库保存
  judgeFileType: function judgeFileType(str) {
    if (str === "image/png" || str === "image/jpeg" || str === "image/jpg") {
      return 2;
    } else {
      return 1;
    }
  },
  handCancle: function handCancle() {
    this.$emit("handCancle");
  }
}), _props$data$props$wat);